<strong class="my-color-blue">{{'__JOURNEY_OVERVIEW__' | translate}}</strong>
<div class="text-formatted" [innerHTML]="courseOverview"></div>
